export default function TestimonialSection() {
  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-5xl mx-auto">
        <div className="grid md:grid-cols-5 gap-8 items-center">
          <div className="md:col-span-2 relative">
            <div className="absolute -top-6 -left-6 w-24 h-24 flex items-center justify-center">
              <i className="ri-double-quotes-l text-8xl text-orange-200"></i>
            </div>
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img 
                src="https://public.readdy.ai/ai/img_res/38e539319c9de8bbaf5f0eb92a99a454.jpg"
                alt="Student Success"
                className="w-full h-96 object-cover object-top"
              />
            </div>
          </div>

          <div className="md:col-span-3 bg-gray-900 rounded-3xl p-10 relative">
            <i className="ri-double-quotes-r text-6xl text-yellow-400/30 mb-6 block"></i>
            
            <p className="text-white text-xl leading-relaxed mb-8">
              Con tôi đã học robotics tại ESAPCOR được 6 tháng. Sự thay đổi thật đáng kinh ngạc! Con không chỉ học được kiến thức về công nghệ mà còn phát triển tư duy logic, khả năng giải quyết vấn đề và làm việc nhóm. Giờ con rất hứng thú với khoa học và công nghệ!
            </p>

            <div className="flex items-center gap-4 mb-6">
              <div className="w-14 h-14 bg-gradient-to-br from-orange-500 to-red-500 rounded-full flex items-center justify-center">
                <span className="text-white font-bold text-xl">NT</span>
              </div>
              <div>
                <h4 className="text-white font-bold text-lg">Nguyễn Thị Mai</h4>
                <p className="text-gray-400 text-sm">Phụ huynh học viên lớp K12</p>
              </div>
            </div>

            <button className="px-8 py-3 bg-pink-500 text-white rounded-full font-semibold hover:bg-pink-600 transition-colors whitespace-nowrap cursor-pointer">
              Xem Thêm Đánh Giá
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}